<template>
    <el-dialog width="30%" :visible="showDialog" :close-on-click-modal="false" @close="close" @open="create" append-to-body top="7vh">
        <form autocomplete="off" @submit.prevent="submit">
            <div class="form-body">
                <div class="row">
                    <div class="col-md-6 mt-3">
                        <div class="form-group">
                            <label class="control-label">Tipo de reporte</label>
                              <el-select v-model="form.type" clear="w-100" clearable>
                                  <el-option label="Stock Lineal" value="stock_lineal"></el-option>
                              </el-select>
                        </div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <div class="form-group">
                            <label class="control-label">Formato</label>
                              <el-select v-model="form.format" clear="w-100" clearable>
                                  <el-option value="pdf"><i class="fa fa-file-pdf"></i> PDF</el-option>
                                  <el-option value="xlsx"><i class="fa fa-file-excel"></i> Excel</el-option>
                              </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions text-right pt-2 mt-3">
                <button @click="close()" class="btn btn-outline-info btn-xs"><i class="fa fa-undo"></i> cerrar</button>
                <button :loading="loading_submit" class="btn btn-outline-success btn-xs" v-if="form.format && form.type"><i class="fa fa-save"></i> Generar</button>
            </div>
        </form>
    </el-dialog>
</template>

<script>

    export default {
        props: ['showDialog', 'recordId'],
        data() {
            return {
                loading_submit: false,
                titleDialog: null,
                resource: 'inventory/report2',
                errors: {},
                form: {},
            }
        },
        created() {
            this.initForm()
        },
        methods: {
            initForm() {
                this.form = {
                    format: null,
                    type: null,
                }

            },
            create() {
            },
            submit() {
                this.loading_submit = true
                this.$http.post(`/${this.resource}/others`, this.form)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.$eventHub.$emit('reloadData')
                            this.close()
                        } else {
                            this.$message.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            // console.log(error.response.data)
                            this.errors = error.response.data.errors
                        } else {
                            console.log(error)
                        }
                    })
                    .then(() => {
                        this.loading_submit = false
                    })
            },
            close() {
                this.initForm()
                this.$emit('update:showDialog', false)
            },
        }
    }

</script>
